import { COOKIE_PERMISSION as r } from "../cookieManagementTypes.mjs";
const O = ({ allowSiteImprovementCookies: E, allowAdvertisingCookies: f }) => {
  let I = `permit ${r.CORE_FUNCTIONALITY}`;
  return !E && !f && (I += " required"), E && (I += `,${r.SITE_IMPROVEMENT}`, f || (I += " functional")), f && (I += `,${r.ADVERTISING}`), I;
};
export {
  O as default
};
